<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1603 10.2922L15.1152 13.248C15.6284 13.7633 15.6284 14.599 15.1142 15.1143C14.8559 15.3714 14.5184 15.5 14.1809 15.5C13.8435 15.5 13.507 15.3714 13.2488 15.1143L10.2938 12.1585C10.2606 12.126 10.2341 12.0906 10.2074 12.0548C10.1988 12.0433 10.1902 12.0317 10.1813 12.0202C9.19885 12.6598 8.02779 13.0348 6.7678 13.0348C3.30712 13.0348 0.5 10.2289 0.5 6.76741C0.5 3.30587 3.30605 0.5 6.76673 0.5C10.2296 0.5 13.0345 3.30587 13.0345 6.76741C13.0345 8.02732 12.6606 9.19616 12.021 10.1786C12.0337 10.1887 12.0467 10.1985 12.0598 10.2084C12.0939 10.2342 12.1285 10.2604 12.1603 10.2922ZM2.47886 6.76741C2.47886 9.13081 4.40313 11.055 6.76668 11.055C9.13023 11.055 11.0545 9.13081 11.0545 6.76741C11.0545 4.40401 9.13023 2.47986 6.76668 2.47986C4.40313 2.47986 2.47886 4.40401 2.47886 6.76741Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class SearchIcon extends Vue {}
</script>
